// Maps KARM's classified `job.country` field to a flag emoji + short label
// for the region badge shown on job cards and the job detail page.
const COUNTRY_BADGES = {
  "India": { flag: "🇮🇳", label: "India" },
  "United States": { flag: "🇺🇸", label: "US" },
  "United Kingdom": { flag: "🇬🇧", label: "UK" },
  "Singapore": { flag: "🇸🇬", label: "Singapore" },
  "Australia": { flag: "🇦🇺", label: "Australia" },
  "Europe": { flag: "🇪🇺", label: "Europe" },
};

export function getCountryBadge(country) {
  if (!country) return null;
  return COUNTRY_BADGES[country] || { flag: "🌐", label: "Global" };
}

// Workday-sourced postings join multiple work locations with ";" — showing a single
// country flag on those is misleading (and can disagree with the one city shown as
// `job.location`). Detect that case and show a neutral "Multi" count badge instead;
// this is DISPLAY-ONLY and never changes `job.country`, so the region filter chips
// (which filter on the single classified `country` field) are unaffected.
export function getLocationBadge(job) {
  const segments = (job.location || "").split(";").map((s) => s.trim()).filter(Boolean);
  if (segments.length > 1) {
    return { flag: "🌍", label: `Multi · ${segments.length} locations` };
  }
  return getCountryBadge(job.country);
}
